module.exports = __webpack_public_path__ + "img/icon_card018.12c74d8c.png";